import * as React from "react";

import firebase from "firebase/app";

import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";

import { Page } from "../Page";

export function SignUpPage(): React.ReactElement {
    const [loading, setLoading] = React.useState(false);

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [passwordVerify, setPasswordVerify] = React.useState("");

    const [showVerify, setShowVerify] = React.useState(false);

    const [error, setError] = React.useState("");

    const handleEmailChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const handlePasswordChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const handlePasswordVerifyChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordVerify(event.target.value);
    };

    const onClick = async () => {
        if (password !== passwordVerify) {
            setError("Passwords do not match.");
            return;
        }

        setLoading(true);

        try {
            const credentials = await firebase.auth().createUserWithEmailAndPassword(email, password);
            const user = credentials.user;

            if (user === null) {
                setError("Login did not produce a valid user.");
                return;
            }
            
            await user.sendEmailVerification();
            await firebase.auth().signOut();

            setShowVerify(true);
        } catch (error) {
            const e = error as Error;

            setError(e.message);
        }

        setLoading(false);
    };

    return (
        <Page>
            <Box mb={2}>
                <Typography variant="h5">Create Quilt Farm account</Typography>
            </Box>
            
            {!showVerify &&
                <Grid container direction="column" alignItems="center" spacing={1}>
                    <Grid item>
                        <TextField fullWidth value={email} onChange={handleEmailChanged} disabled={loading} label="Email" type="email" autoComplete="email"/>
                    </Grid>
                    <Grid item>
                        <TextField fullWidth value={password} onChange={handlePasswordChanged} disabled={loading} label="Password" type="password" autoComplete="new-password"/>
                    </Grid>
                    <Grid item>
                        <TextField fullWidth value={passwordVerify} onChange={handlePasswordVerifyChanged} disabled={loading} label="Verify Password" type="password" autoComplete="new-password"/>
                    </Grid>
                    <Grid item>
                        <Button onClick={onClick} disabled={loading} variant="contained" color="primary">Create account</Button>
                    </Grid>
                    {error.length !== 0 &&
                        <Grid item>
                            <Typography color="error">{error}</Typography>
                        </Grid>
                    }
                </Grid>
            }
            {showVerify && 
                <>
                    <Typography>A verification e-mail was sent to your e-mail address.</Typography>
                    <Typography>Click the link in it to verify your e-mail address and activate your account.</Typography>
                </>
            }
        </Page>
    );
}